import * as React from 'react';

import * as styles from './styles.css';

export const ReportCard: React.FC = () => {
  return <div className={styles['container']} />;
};

ReportCard.displayName = 'ReportCard';
